import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import "./Experience.css";
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Experience = () => {
  const { currentLang, texts } = useContext(LanguageContext);
  const swiperRef = useRef(null);

  const [expData, setExpData] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchExperience = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/ExperienceSection?lang=${currentLang}`
        );
        setExpData(res.data);
      } catch (err) {
        console.error("Error fetching Experience Section:", err);
      }
    };

    fetchExperience();
  }, [currentLang]);

  if (!expData) return null;

  return (
    <div className="experience-wrapper">
      {/* TOP INTRO SECTION (DYNAMIC) */}
      <section className="experience-top">
        <h1 className="exp-title">{expData.title}</h1>
        <p className="exp-desc">{expData.description}</p>

        <div className="exp-buttons">
          <Link to="/testdrive" className="exp-btn-blue" type="button">
            {expData.button1}
          </Link>
          {/* <Link to="/campaigns" className="exp-btn-blue" type="button">
            {expData.button2}
          </Link> */}
        </div>
      </section>

      {/* MODELS SLIDER (DYNAMIC) */}
      <section className="models-section">
        <div className="models-header">
          <h2>Our models</h2>
        </div>

        <div className="models-slider-wrapper">
          <Swiper
            className="models-swiper"
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            slidesPerView={1}
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 20 },
              576: { slidesPerView: 1, spaceBetween: 25 },
              768: { slidesPerView: 2, spaceBetween: 30 },
              992: { slidesPerView: 2.4, spaceBetween: 35 },
              1200: { slidesPerView: 3, spaceBetween: 40 },
              1600: { slidesPerView: 3.2, spaceBetween: 50 },
            }}
          >
            {Array.isArray(expData.models) &&
              expData.models.map((m) => {
                const nameLower = (m?.name || "").toLowerCase().trim();

                const slug = (() => {
                  if (nameLower.includes("free")) return "/voyah-free";
                  if (nameLower.includes("dream")) return "/voyah-dream";
                  if (nameLower.includes("courage")) return "/voyah-courage";
                  if (nameLower.includes("taishan")) return "/voyah-taishan";
                  return "/models";
                })();

                return (
                  <SwiperSlide key={m.id ?? m.name}>
                    <Link to={slug} className="model-cardB">
                      <div className="model-image">
                        <img src={resolveUrl(m.img)} alt={m.name || "Model"} />
                      </div>

                      <div className="model-content">
                        <p className="model-title">{m.name}</p>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}

            {/* Optional last slide */}
            <SwiperSlide key="last-slide">
              <div className="model-cardB model-last">
                <div className="model-content">
                  <h3>{texts.experience?.moreModels}</h3>
                  <Link to="/contact" className="model-last-contact-btn">
                    {texts.experience?.contactUs}
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* ARROWS (custom) */}
          <div className="models-arrows">
            <div
              className="arrow-left"
              role="button"
              tabIndex={0}
              onClick={() => swiperRef.current?.slidePrev?.()}
              onKeyDown={(e) => {
                if (e.key === "Enter") swiperRef.current?.slidePrev?.();
              }}
            >
              ←
            </div>
            <div
              className="arrow-right"
              role="button"
              tabIndex={0}
              onClick={() => swiperRef.current?.slideNext?.()}
              onKeyDown={(e) => {
                if (e.key === "Enter") swiperRef.current?.slideNext?.();
              }}
            >
              →
            </div>
          </div>
        </div>
      </section>

      {/* SECOND TEXT SECTION (DYNAMIC) */}
      <section className="experience-top">
        <h1 className="exp-title">{expData.secondTitle}</h1>
        <p className="exp-desc">{expData.secondDescription}</p>

        <div className="exp-buttons">
          <button className="exp-btn-blue" type="button">
            {expData.secondButton}
          </button>
        </div>
      </section>
    </div>
  );
};

export default Experience;
